var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCirclePending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9974 10.9995C19.9974 15.6925 16.193 19.497 11.4999 19.497C6.8069 19.497 3.00244 15.6925 3.00244 10.9995C3.00244 6.30641 6.8069 2.50195 11.4999 2.50195C16.193 2.50195 19.9974 6.30641 19.9974 10.9995Z",
    fill: "#F2F2F2",
    stroke: "#C6C6C6",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 20.4408C16.7147 20.4408 20.942 16.2134 20.942 10.9987C20.942 5.784 16.7147 1.55664 11.4999 1.55664C6.28523 1.55664 2.05786 5.784 2.05786 10.9987C2.05786 16.2134 6.28523 20.4408 11.4999 20.4408Z",
    fill: "#F2F2F2",
    stroke: "#C6C6C6",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCirclePending);
export default __webpack_public_path__ + "static/media/checkbox-circle-pending.dfa75816b3cef25491fb8a6083dcc1f1.svg";
export { ForwardRef as ReactComponent };